@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.payments.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/mobile_wallet.feature.payments.generated.resources/"

public val Res.string.feature_payments_inter_bank_transfer_description: StringResource by lazy {
      StringResource("string:feature_payments_inter_bank_transfer_description", "feature_payments_inter_bank_transfer_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 112),
      ))
    }

public val Res.string.feature_payments_inter_bank_transfer_title: StringResource by lazy {
      StringResource("string:feature_payments_inter_bank_transfer_title", "feature_payments_inter_bank_transfer_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 123, 78),
      ))
    }

public val Res.string.feature_payments_intra_bank_transfer_description: StringResource by lazy {
      StringResource("string:feature_payments_intra_bank_transfer_description", "feature_payments_intra_bank_transfer_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 202, 116),
      ))
    }

public val Res.string.feature_payments_intra_bank_transfer_title: StringResource by lazy {
      StringResource("string:feature_payments_intra_bank_transfer_title", "feature_payments_intra_bank_transfer_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 319, 78),
      ))
    }

public val Res.string.feature_payments_mobile_number: StringResource by lazy {
      StringResource("string:feature_payments_mobile_number", "feature_payments_mobile_number", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 398, 58),
      ))
    }

public val Res.string.feature_payments_receive: StringResource by lazy {
      StringResource("string:feature_payments_receive", "feature_payments_receive", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 457, 44),
      ))
    }

public val Res.string.feature_payments_select_transfer_type_header: StringResource by lazy {
      StringResource("string:feature_payments_select_transfer_type_header", "feature_payments_select_transfer_type_header", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 502, 108),
      ))
    }

public val Res.string.feature_payments_select_transfer_type_subtitle: StringResource by lazy {
      StringResource("string:feature_payments_select_transfer_type_subtitle", "feature_payments_select_transfer_type_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 611, 94),
      ))
    }

public val Res.string.feature_payments_show_code: StringResource by lazy {
      StringResource("string:feature_payments_show_code", "feature_payments_show_code", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 706, 46),
      ))
    }

public val Res.string.feature_payments_transfer_options_title: StringResource by lazy {
      StringResource("string:feature_payments_transfer_options_title", "feature_payments_transfer_options_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 753, 71),
      ))
    }

public val Res.string.feature_payments_vpa: StringResource by lazy {
      StringResource("string:feature_payments_vpa", "feature_payments_vpa", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 825, 68),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_payments_inter_bank_transfer_description", Res.string.feature_payments_inter_bank_transfer_description)
  map.put("feature_payments_inter_bank_transfer_title", Res.string.feature_payments_inter_bank_transfer_title)
  map.put("feature_payments_intra_bank_transfer_description", Res.string.feature_payments_intra_bank_transfer_description)
  map.put("feature_payments_intra_bank_transfer_title", Res.string.feature_payments_intra_bank_transfer_title)
  map.put("feature_payments_mobile_number", Res.string.feature_payments_mobile_number)
  map.put("feature_payments_receive", Res.string.feature_payments_receive)
  map.put("feature_payments_select_transfer_type_header", Res.string.feature_payments_select_transfer_type_header)
  map.put("feature_payments_select_transfer_type_subtitle", Res.string.feature_payments_select_transfer_type_subtitle)
  map.put("feature_payments_show_code", Res.string.feature_payments_show_code)
  map.put("feature_payments_transfer_options_title", Res.string.feature_payments_transfer_options_title)
  map.put("feature_payments_vpa", Res.string.feature_payments_vpa)
}
